/**
 * The two currencies, and Soul Dust, drawn once each.
 *
 * Every price chip, till balance, reward count and top-up row used the 💠 and 💧 emoji, which
 * render as a different glyph on every platform and are the reason the screens whose whole
 * subject is a currency had no picture of it. The assets now exist in the house style
 * (`public/img/suika-drop.png`, `public/img/soul-shard.png`) and this component is here so the
 * call sites cannot drift into a different size each.
 *
 * **There is a second shard drawing** — `components/campaign/SoulShardIcon.tsx`, an SVG in the
 * campaign's emerald/gold language, used by the "Soul Saved!" celebration and the Souls gallery.
 * That is a duplicate of this one and should not stay: see MY_TODOS. It is left alone here
 * because retiring it changes how the campaign celebration looks, which is not this change's call.
 *
 * Decorative in every position: the amount beside it is the accessible text, and each buy button
 * already carries an `aria-label` naming the currency.
 */
import './CurrencyIcon.css';

/**
 * `suika` is Suika — the game's one currency since Scrolls were removed (Beta 21.53).
 * `tracks` is the Suikadex currency (per species, spent to hatch one) — **Soul Shards** to the
 * player since 2026-09-28, so it is drawn as the Soul Shard crystal (it was a paw print while it
 * was called Tracks).
 */
export type Currency = 'suika' | 'tracks';

const ART: Record<Currency, string> = {
  suika: '/img/suika-drop.png',
  tracks: '/img/soul-shard.png',
};

interface CurrencyIconProps {
  currency: Currency;
  /** `inline` sits beside a number in a button or chip; `hero` is the page's artwork. */
  size?: 'inline' | 'hero';
}

export const CurrencyIcon = ({ currency, size = 'inline' }: CurrencyIconProps) => (
  <img
    className={`currency-icon currency-icon--${size}`}
    src={ART[currency]}
    alt=""
    aria-hidden="true"
    loading="lazy"
    decoding="async"
  />
);
